/**
 * Events Carousel for Home Page
 * Carousel simple slide par slide avec GSAP
 */

import { gsap } from 'gsap';

export function initEventsCarouselHome() {
  const carousel = document.querySelector('.events-carousel-home');
  
  if (!carousel) {
    return;
  }

  const track = carousel.querySelector('.carousel-track');
  const slides = Array.from(carousel.querySelectorAll('.event-card'));
  const prevBtn = document.querySelector('.carousel-button-prev-home');
  const nextBtn = document.querySelector('.carousel-button-next-home');
  const dotsContainer = carousel.querySelector('.carousel-pagination');

  if (!slides.length) {
    return;
  }

  let currentIndex = 0;

  // Création des dots de pagination (un par position possible)
  function createPagination() {
    if (!dotsContainer) return;
    
    dotsContainer.innerHTML = '';
    
    // Le nombre de positions possibles = nombre de slides - slides visibles + 1
    const maxIndex = slides.length - getSlidesPerView();
    const totalPositions = maxIndex + 1;
    
    for (let i = 0; i < totalPositions; i++) {
      const dot = document.createElement('span');
      dot.classList.add('carousel-dot');
      if (i === 0) dot.classList.add('active');
      dot.addEventListener('click', () => goToSlide(i));
      dotsContainer.appendChild(dot);
    }
  }

  // Aller à un slide spécifique
  function goToSlide(index) {
    currentIndex = Math.max(0, Math.min(index, slides.length - 1));
    updateCarousel();
  }

  // Mettre à jour le carousel
  function updateCarousel() {
    const slide = slides[0];
    if (!slide) return;
    
    const slideWidth = slide.offsetWidth;
    const gap = getGap();
    const offset = -(currentIndex * (slideWidth + gap));

    gsap.to(track, {
      x: offset,
      duration: 0.5,
      ease: 'power2.out',
    });

    // Mise à jour des dots
    if (dotsContainer) {
      const dots = dotsContainer.querySelectorAll('.carousel-dot');
      dots.forEach((dot, index) => {
        dot.classList.toggle('active', index === currentIndex);
      });
    }

    // Mise à jour des boutons
    updateButtons();
  }

  // Obtenir le nombre de slides visibles
  function getSlidesPerView() {
    const width = window.innerWidth;
    if (width >= 1024) return 3;
    if (width >= 640) return 2;
    return 1;
  }

  // Obtenir le gap selon l'écran
  function getGap() {
    return window.innerWidth >= 768 ? 30 : 20;
  }

  // Mettre à jour l'état des boutons
  function updateButtons() {
    const maxIndex = slides.length - getSlidesPerView();
    
    if (prevBtn) {
      prevBtn.classList.toggle('disabled', currentIndex === 0);
    }
    
    if (nextBtn) {
      nextBtn.classList.toggle('disabled', currentIndex >= maxIndex);
    }
  }

  // Navigation suivante
  function goNext() {
    const maxIndex = slides.length - getSlidesPerView();
    if (currentIndex < maxIndex) {
      currentIndex++;
      updateCarousel();
    }
  }

  // Navigation précédente
  function goPrev() {
    if (currentIndex > 0) {
      currentIndex--;
      updateCarousel();
    }
  }

  // Event listeners
  if (nextBtn) {
    nextBtn.addEventListener('click', goNext);
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', goPrev);
  }

  // Responsive
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      updateCarousel();
    }, 250);
  });

  // Initialisation
  createPagination();
  updateCarousel();
}
